import MyBatchStudentDetailsTable from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchStudentDetailsTable";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { Card } from "antd";
export const CustomMyBatchCard = styled<any>(Card)`
  border-top: 0px !important;
  border-radius: 0px !important;
  .ant-card-body {
    padding: ${({ screen }: any) =>
      ["xxl", "xl", "lg"].includes(screen)
        ? "0 16px 16px 0px !important"
        : "0px !important"};
    border-radius: 0px !important;
  }
`;
const MainDiv = styled<any>("div")`
  padding-right: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "0px" : "0px"};
  margin-top: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "0px" : "0px"};
`;
const MyBatchStudentDetailTab = ({
  loader,
  data,
  pagination,
  setPagination,
}: any) => {
  const { screen }: any = useWindowSize();
  return (
    <CustomMyBatchCard screen={screen}>
      <MainDiv screen={screen}>
        <TableLayoutAntd isLoader={loader}>
          <MyBatchStudentDetailsTable
            data={data}
            access="Batches"
            pagination={pagination}
            setPagination={setPagination}
          ></MyBatchStudentDetailsTable>
        </TableLayoutAntd>
      </MainDiv>
    </CustomMyBatchCard>
  );
};
export default MyBatchStudentDetailTab;
